import generateUtilityClass from "../../../utils/generateUtilityClass/generateUtilityClass.es.js";
import generateUtilityClasses from "../../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
function getPickersPopperUtilityClass(slot) {
  return generateUtilityClass("MuiPickersPopper", slot);
}
generateUtilityClasses("MuiPickersPopper", ["root", "paper"]);
export {
  getPickersPopperUtilityClass
};
//# sourceMappingURL=pickersPopperClasses.es.js.map
